export var SystemFolder;
(function (SystemFolder) {
    SystemFolder[SystemFolder["System"] = 0] = "System";
    SystemFolder[SystemFolder["Accounts"] = 1] = "Accounts";
    SystemFolder[SystemFolder["Groups"] = 2] = "Groups";
    SystemFolder[SystemFolder["Settings"] = 3] = "Settings";
    SystemFolder[SystemFolder["Protocols"] = 4] = "Protocols";
    SystemFolder[SystemFolder["ServicesProtocols"] = 5] = "ServicesProtocols";
    SystemFolder[SystemFolder["ManagerProtocols"] = 6] = "ManagerProtocols";
    SystemFolder[SystemFolder["DataStructures"] = 7] = "DataStructures";
    SystemFolder[SystemFolder["Components"] = 8] = "Components";
    SystemFolder[SystemFolder["RecycleBin"] = 9] = "RecycleBin";
    SystemFolder[SystemFolder["Users"] = 10] = "Users";
    SystemFolder[SystemFolder["Modules"] = 11] = "Modules";
    SystemFolder[SystemFolder["CommonDataElements"] = 12] = "CommonDataElements";
    SystemFolder[SystemFolder["ExternalServices"] = 13] = "ExternalServices";
    SystemFolder[SystemFolder["UserDefinedFolderTypes"] = 14] = "UserDefinedFolderTypes";
    SystemFolder[SystemFolder["FlowManagement"] = 15] = "FlowManagement";
    SystemFolder[SystemFolder["FlowData"] = 16] = "FlowData";
    SystemFolder[SystemFolder["FlowAssignments"] = 17] = "FlowAssignments";
    SystemFolder[SystemFolder["Images"] = 18] = "Images";
})(SystemFolder || (SystemFolder = {}));
;
